import { render, staticRenderFns } from "./japanese_onetoone_appointment.vue?vue&type=template&id=c22a7bf2&scoped=true"
import script from "./japanese_onetoone_appointment.vue?vue&type=script&lang=js"
export * from "./japanese_onetoone_appointment.vue?vue&type=script&lang=js"
import style0 from "./japanese_onetoone_appointment.vue?vue&type=style&index=0&id=c22a7bf2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22a7bf2",
  null
  
)

export default component.exports